import Handler from "./Handler";
import DiscussionModel from "../models/DiscussionModel";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";

export default class LoginHandler extends Handler {

    public handle(model: DiscussionModel, action: string, params?: any): DiscussionModel {
        switch (action) {
            case "verify":
                return this.handleVerify(model, params);
            case "verify/confirm":
                return this.handleConfirm(model, params);
            case "verify/cancel":
                return this.handleCancel(model, params);
            default:
                return model;
        }
    }

    private handleVerify(model: DiscussionModel, params: any): DiscussionModel {
        model = model.showModalVerify();
        return model;
    }

    private handleConfirm(model: DiscussionModel, params: any): DiscussionModel {

        window.setTimeout(() => {
            location.assign(model.getVerify());
        }, 1);

        model = model.hideModalVerify();
        return model;
    }

    private handleCancel(model: DiscussionModel, params: any): DiscussionModel {
        model = model.hideModalVerify();
        return model;
    }

}